import { Notification } from '@copera/notification';
import { useSnackbar } from 'notistack';
import { NotificationCard } from './NotificationCard';

export const useInAppNotification = () => {
  const { enqueueSnackbar } = useSnackbar();

  const notify = (notification: Notification) => {
    enqueueSnackbar(<NotificationCard notification={notification} />, {
      variant: 'default',
    });
  };

  return {
    notify,
  };
};
